<template>
    <div class="commer-content box-sizing broadband">
        <div class="commer-list">
            <p class="commer-list-title">
				宽带管理>宽带列表
			</p>
            <div class="commer-list-seacch-box" style="margin-bottom: 40px;">
                <div class="left-search">
                    <el-select v-model="getListParams.projectId" placeholder="请选择项目" clearable >
                        <el-option
                            v-for="item in ProjectList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                    <el-button type="primary" size="mini" @click='getList(1,"")'>查询</el-button>
                </div>
                <div class="right-add">
                    <el-button type="info" icon="el-icon-plus" @click='operation(1,"")'>新增</el-button>
                </div>
            </div>
            <div class="table-list">
				<el-table
					:data="tableData"
					border
					style="width: 100%">
					<el-table-column
						type="index"
						label="序号"
						width="70">
					</el-table-column>
                    <el-table-column
                        prop="broadbandPhone"
                        label="宽带号码">
                    </el-table-column>
                    <el-table-column
                        prop="contactName"
                        label="负责人">
                    </el-table-column>
                    <el-table-column
                        prop="networkType"
                        label="网络类型">
                    </el-table-column>
                    <el-table-column
                        prop="instalPosition"
                        label="安装位置">
                    </el-table-column>
                    <el-table-column
                        prop="instalTime"
                        label="安装时间">
                        <template slot-scope="scope">
                            <span>{{$moment(scope.row.instalTime).format('YYYY-MM-DD HH:mm:ss') }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="expireTime"
                        label="到期时间">
                        <template slot-scope="scope">
                            <span>{{$moment(scope.row.expireTime).format('YYYY-MM-DD HH:mm:ss') }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="操作"
                        width="220">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click='operation(2,scope.row.id)'>编辑</el-button>
                            <el-button type="text" size="small"  @click='ifDelete(scope.row.id)'>删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <el-dialog
		:title="titleMsg"
		:visible.sync="ifAdd"
		:modal-append-to-body='false'
        class="my-self-dialog"
		width='50%'>
            <el-main>
                <el-form :model="addParams" ref="addParams" label-width="100px" class="demo-ruleForm" :rules="rules">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="宽带号码" prop="broadbandPhone">
                                <el-input v-model="addParams.broadbandPhone" placeholder="请输入宽带号码"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="负责人" prop="contactName">
                                <el-input v-model="addParams.contactName" placeholder="请输入负责人"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="网络类型" prop="networkType">
                                <el-input v-model="addParams.networkType" placeholder="请输入网络类型"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="安装位置" prop="instalPosition">
                                <el-input v-model="addParams.instalPosition" placeholder="请输入安装位置"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="安装时间" prop="instalTime">
                                <el-date-picker
                                    v-model="addParams.instalTime"
                                    type="datetime"
                                    placeholder="选择安装时间">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="到期时间" prop="expireTime">
                                <el-date-picker
                                    v-model="addParams.expireTime"
                                    type="datetime"
                                    placeholder="选择到期时间">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="套餐信息" prop="content">
                                <el-input
                                    type="textarea"
                                    :rows="4"
                                    placeholder="套餐信息"
                                    v-model="addParams.content">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-main>
            <span slot="footer" class="dialog-footer">
				<el-button @click="ifAdd = false">取 消</el-button>
				<el-button type="primary" @click="save('addParams')"> 保 存</el-button>
			</span>
        </el-dialog>
    </div>
</template>
<script>
    export default{
        data(){
            return{
                ifAdd:false,
                titleMsg:'新增',
                getListParams:{
                    pageNo:1,
                    pageSize:10,
                    projectId:''
                },
                tableData:[],
                totals:0,
                ProjectList:[],
                addParams:{
                    broadbandPhone : "" ,// 宽带号码,
                    contactName : "",// 负责人,
                    networkType : "", // 网络类型,
                    instalPosition : "", // 安装位置,
                    instalTime : "", // 安装时间,
                    expireTime : "", // 到期时间,
                    content : "" ,// 套餐信息
                },
                rules:{

                }
            }
        },
        mounted(){
            this.queryProject()
            this.getList()
        },
        methods:{
            //获取列表
            getList(type){
                var vm=this;
                vm.getListParams.pageNo=type?type:1
                vm.$http.get('/api/console/broadband/queryPage',
                    {params:vm.getListParams}
                )
                .then(function(response){
                    vm.tableData=response.data&&response.data.items?response.data.items:[]
                    vm.totals=parseInt(response.data.page.rowCount)*1
                })
            },
             //出现新增框
            operation:function(operationStatus,companyID){
                var vm=this;
                this.ifAdd=true
                this.$nextTick(()=>{
                    this.$refs['addParams'].resetFields();
                }) 
                if(operationStatus==1){
                    vm.$common.deletesObj(vm.addParams,'id')
                    vm.titleMsg='新增'
                }else{
                    vm.titleMsg='编辑'
                    vm.$http.get('/api/console/broadband/query',{
                        params:{
                                id:companyID
                            },
                    })
                    .then(function(response){
                        vm.addParams=response.data
                        // for(var i in resTemp){
                        //     if(i=='updateDate'||i=='createDate'){
                        //         delete resTemp[i]
                        //     }
                        // }
                        // vm.addParams=resTemp
                    })
                    
                
                }
            },
            queryProject(){
                var vm=this;
                vm.$http.get('/api/console/broadband/queryProject')
                .then(function(res){
                    vm.ProjectList=res.data?res.data:[]
                })
            },
            //新增编辑数据
            save:function(formName){
                
                var vm=this;
                vm.$refs[formName].validate((valid) => {
                    if (valid) {
                        vm.addParams.instalTime=vm.$moment(vm.addParams.instalTime).format('YYYY-MM-DD HH:mm:ss')
                        vm.addParams.expireTime=vm.$moment(vm.addParams.expireTime).format('YYYY-MM-DD HH:mm:ss')
                        vm.$http.post('/api/console/broadband/save',vm.addParams)
                        .then(function(response){
                            if(response.code==0){
                                vm.$common.Alerts.call(vm,"保存成功",2)
                                vm.ifAdd=false;
                                vm.getList(vm.getListParams.pageNo)
                            }
                        })
                    }
                })

                
            },
            ifDelete:function(companyID){
                var vm=this;
                // this.ifDeleteBox=true
                this.$common.Delets.call(this,(action, instance, done)=>{
                    if (action === 'confirm') {
                        vm.$http.post('/api/console/broadband/delete',{id:companyID})
                        .then(function(response){
                            if(response.code==0){
                                done()
                                vm.$common.Alerts.call(vm,"删除成功",2)
                                // vm.ifDeleteBox=false
                                vm.getList()
                            }
                                
                        })
                    }else{
                        done()
                    }
                })
            },
        }
    }
</script>
<style lang="less">
.broadband{
    .left-search{
        .el-select{
            max-width: 200px;
        }
    }
    .my-self-dialog{
        .el-date-editor.el-input, .el-date-editor.el-input__inner{
            width: 100%;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/broadband/broadband.vue